import { Icon, message, Upload, Button, Modal } from 'antd';
import request from 'superagent';
import React from 'react';
import { invoiceManage } from 'src/api';
class Component extends React.Component<any, any> {
    //关联影像弹框界面
    constructor(props: any) {
        super(props);
        this.state = {
            callback: null,
            keyPrefix: '',
            token: null,
            uploadUrl: null,
            connectId: this.props.connectId,//connectId实际上是invoiceManageId
            companyId: this.props.companyId,
            connectImage: !!this.props.connectImage,//是否上传过图片
            fileList: [],
            fileName: null,
            uploading: false,
        };
    }
    componentDidMount() {
        if (this.state.connectImage) {
            this.getImage();
        }
    }
    getImage = () => {
        invoiceManage.connectImage(this, { invoiceManageId: this.state.connectId }).then((response: any) => {
            const err = response.err;
            const res = response.res;
            if (err) {
                message.error(err.status.description);
                return null;
            } else {
                if (res) {
                    this.setState({
                        fileList: [{
                            uid: 1,
                            name: res.imagePath.split('/')[1],
                            status: 'done',
                            url: res.originFileUrl,
                        }]
                    });
                }
            }
        });
    }
    getToken = () => {
        let data = {
            manageId: this.state.connectId,
            fileName: this.state.fileList[0].name
        };
        invoiceManage.uploadToken(this, data).then((response: any) => {
            const err = response.err;
            const res = response.res;
            if (err) {
                message.error(err.status.description);
                return null;
            } else {
                if (res) {
                    this.setState({
                        keyPrefix: res.keyPrefix,
                        token: res.token,
                        uploadUrl: res.uploadUrl
                    });
                } else {
                    this.setState({
                        token: null,
                        uploadUrl: null,
                        keyPrefix: null
                    });
                }
            }
        });

    }
    handleCancel = () => {
        this.props.closeConnect();
    }
    handleUpload = () => {
        const { fileList, keyPrefix, token, uploadUrl } = this.state;

        const formData = new FormData();
        fileList.forEach((file) => {
            formData.append('files[]', file);
        });
        this.setState({
            uploading: true,
        });
        request.post('//' + uploadUrl)
            .field({ key: keyPrefix, token: token })
            .attach('file', fileList[0])
            .end((err, response) => {
                this.setState({
                    uploading: false,
                    token: null
                });
                window.setTimeout(() => {

                    this.setState({
                        fileName: `${fileList[0].name}`
                    });
                    this.getImage();
                    this.props.getDataList();
                    message.success(`文件上传成功`);
                }, 1000);
            });

    }

    render() {
        let { keyPrefix, token, uploadUrl, uploading } = this.state;
        const props = {
            fileList: this.state.fileList,
            action: '//' + uploadUrl,
            showUploadList: { showPreviewIcon: true, showRemoveIcon: false },
            beforeUpload: (file) => {
                let fileName = file.name;
                if (fileName.match(/\s/g)) {
                    message.error('上传文件名不能包含空格');
                    return false;
                }
                this.setState({
                    fileList: [file]
                }, () => { this.getToken(); });

                return false;
            }
        };
        return (
            <Modal
                className="modalsty"
                visible={true}
                onCancel={this.handleCancel}
                footer={null}
            >
                <Upload {...props} accept="image/*">
                    <Button>
                        <Icon type="upload" /> 选择关联影像
                    </Button>

                </Upload>
                <Button
                    style={{ marginTop: 10 }}
                    className="ml-10"
                    type="primary"
                    onClick={this.handleUpload}
                    disabled={!!token === false}
                    loading={uploading}
                >
                    {uploading ? '上传中' : '上传关联影像'}
                </Button>
            </Modal>
        );
    }
}
export default Component;



// WEBPACK FOOTER //
// ./src/display/apps/InvoiceManage/ConnectImage.tsx